export default "/videos/e55970b4b245d286f5deda83e1bd843d.mp4";